import $ from 'jquery';
import { TAO_KOE, EN_KO, TaoCookieJar } from './../libs/';

const CookiePopup = function( element, type ) {
	this.$element = $( element );
	this.type = type;

	this.$element.data( 'cookie-popup', this );
	this.addListeners();
	this.setInitialised();
};

CookiePopup.prototype.setInitialised = function() {
	EN_KO.settings = EN_KO.settings || {};
	EN_KO.settings.consentCookie = EN_KO.settings.consentCookie || 'consentAll';

	const strCookie = TaoCookieJar.get_cookie( EN_KO.settings.consentCookie );

	if ( 'undefined' === typeof strCookie ) {
		if ( ! this.$element.hasClass( 'on_privacy_page' ) ) {
			this.open();
		}
	} else {
		this.trigger_load( strCookie );
	}

	if ( document.location.href.indexOf( 'cookie-notice=1' ) !== -1 ) {
		this.open();
	}
};

CookiePopup.prototype.addListeners = function() {
	const self = this;

	this.$element.on( 'click', '.tao_button_cookie_settings', function() {
		return ! self.do_action( $( this ).data( 'action' ) );
	} );

	this.$element.on( 'click', '.infobox', function() {
		self.show_info( $( this ).data( 'href' ) );
	} );
};

CookiePopup.prototype.open = function() {
	if ( 'popup' === this.type ) {
		TAO_KOE.open_popup( this.$element );
	} else {
		this.$element.removeClass( 'en_hidden' );
	}
};

CookiePopup.prototype.close = function() {
	if ( 'popup' === this.type ) {
		this.$element.data( 'closeable', true );
		TAO_KOE.close_popup( this.$element );
	} else {
		this.$element.addClass( 'en_hidden' );
	}
};

CookiePopup.prototype.show_info = function( next ) {
	const self = this;

	const $info = self.$element.find( '.info' );
	const $next = $info.filter( function() {
		return $( this ).data( 'info' ) === next;
	} );

	if ( self.info ) {
		$info.stop().slideUp( 400, function() {
			if ( next !== self.info ) {
				$( this ).not( $next ).hide();
			} else {
				$( this ).hide();
			}
		} );
	}

	// This works.
	$.when( $info ).then( function() {
		const $container = $next.closest( '.mdl_content' );

		if ( next !== self.info ) {
			$next.stop().slideDown( 400, function() {
				const offsetTop = $container.find( '.cookie_settings_form' ).get( 0 ).offsetTop;
				const parentTop = $container.scrollTop();

				if ( offsetTop + 50 > parentTop ) {
					$container.scrollTop( offsetTop );
				}
			} );
			self.info = next;
		} else {
			self.info = false;
		}
	} );
};

CookiePopup.prototype.get_checked_value = function() {
	const $form = this.$element.find( '.cookie_settings_form' );
	const $data = $form.serializeArray();

	if ( $form.find( 'input:checked' ).not( ':disabled' ).length === 0 ) {
		return '0';
	}

	if ( $data.length === $form.find( 'input' ).not( ':disabled' ).length ) {
		return '1';
	}

	return $.map( $data, function( serialized ) {
		return serialized.value;
	} ).filter( function( value ) {
		return value > 0;
	} ).join( '|' );
};

CookiePopup.prototype.do_action = function( action ) {
	let status = true;
	let checked = '0';

	switch ( action ) {
		case 'individual':
			this.$element.find( '.tao_cookie_popup_simple' ).addClass( 'en_hidden' );
			this.$element.find( '.tao_cookie_popup_advanced' ).removeClass( 'en_hidden' );
			return;

		case 'decline':
			status = false;
			checked = '0';
			break;

		case 'save':
		// Cookie Functional is for Google Analytics, so important.
			status = this.$element.find( 'input[value=2]' ).is( ':checked' );
			checked = this.get_checked_value( this.$element );
			break;

		case 'confirm':
			status = true;
			checked = '1';
			break;

		default:
			return false;
	}

	this.close();
	this.save_cookies( checked );
	this.track_status( status );

	this.trigger_load( checked );
	return true;
};

CookiePopup.prototype.trigger_load = function( strCookie ) {
	// Split the cookie_string ( and handle as an array ).
	const arrCookie = ( '' + strCookie ).split( '|' );

	// Tracking Cookies = 2.
	if ( arrCookie.includes( '1' ) || arrCookie.includes( '2' ) ) {
		$( window ).trigger( 'load_tracking_scripts.en' );
	}

	// Marketing Cookies = 3.
	if ( arrCookie.includes( '1' ) || arrCookie.includes( '3' ) ) {
		$( window ).trigger( 'load_marketing_scripts.en' );
	}

	$( window ).trigger( 'load_triggered_script.en' );
	window.dispatchEvent( new CustomEvent( 'load_triggered_script.tao', { 'detail': arrCookie } ) );
};

CookiePopup.prototype.save_cookies = function( checked ) {
	const settings = {
		'path': '/',
		'max-age': 365 * 24 * 60 * 60,
	};

	const dataLayer = window.dataLayer = window.dataLayer || [];

	//Set Cookie for future loads.
	TaoCookieJar.set_cookie( EN_KO.settings.consentCookie, checked, settings );

	//Send Event to GTM dataLayer.
	dataLayer.push( {
		event: 'consent_changed',
		consentAll: checked,
	} );
};

CookiePopup.prototype.track_status = function( status ) {
	// Disable for now.
	const trackCookieStatus = false;
	if ( trackCookieStatus ) {
		// Track cookie counter.
		$.get( '/dispatch/cookie/status/', {
			status: status ? 1 : 0,
		} );
	}
};

CookiePopup.init = function( resolve ) {
	TAO_KOE.console.log( 'INIT COOKIE POPUP' );

	// This only concerns us if cookies are enabled.
	if ( ! navigator.cookieEnabled ) {
		// Resolve successfully.
		return resolve();
	}

	$( window ).one( 'load_triggered_script.en', function() {
		// When we load the Scripts, the promise is successful.
		TAO_KOE.console.log( 'RESOLVE COOKIE POPUP' );
		resolve();
	} );

	if ( $( '#popup_cookie_settings' ).length > 0 ) {
		new CookiePopup( $( '#popup_cookie_settings' ), 'popup' );
	} else if ( $( '#quickview_cookie_settings' ).length > 0 ) {
		new CookiePopup( $( '#quickview_cookie_settings' ), 'popup' );
	} else if ( $( '#banner_cookie_settings' ).length > 0 ) {
		new CookiePopup( $( '#banner_cookie_settings' ), 'banner' );
	} else {
		resolve();
	}
};

// Init.
//TAO_KOE.chainReady( 'cookie.js', CookiePopup.init, 20 );

// Expose.
TAO_KOE.CookiePopup = CookiePopup;
export default CookiePopup;
